<template>
  <div class="wrappNextCompetition">
    <div class="title">
      {{ $t('competitions.main.competitionNext')+' "' + data.cmp_theme + '"' }}
    </div>
    <div class="text">{{ data.cmp_description }}</div>
    <div class="subTitle">
      {{
        $t('competitions.main.duration') +
          $moment
            .utc(data.cmp_from_post)
            .local()
            .format('DD.MM.YYYY. HH:mm') + ' '+
        $t('competitions.main.until') + ' ' +
          $moment
            .utc(data.cmp_to_vote)
            .local()
            .format('DD.MM.YYYY. HH:mm') +
        $t('competitions.main.hours') +'.'
      }}
    </div>
    <ul>
      <li>
        {{
          $t('competitions.main.sendingReceiving') +
            $moment
              .utc(data.cmp_from_post)
              .local()
              .format('DD.MM.YYYY. HH:mm') + ' '+
              $t('competitions.main.until') + ' ' +
            $moment
              .utc(data.cmp_to_post)
              .local()
              .format('DD.MM.YYYY. HH:mm') +
              $t('competitions.main.hours') 
        }}
      </li>
      <li>
        {{
          $t('competitions.main.voteStart') +
            $moment
              .utc(data.cmp_from_vote)
              .local()
              .format('DD.MM.YYYY. HH:mm') +
            $t('competitions.main.hoursTo') +
            $moment
              .utc(data.cmp_to_vote)
              .local()
              .format('DD.MM.YYYY. HH:mm') +
            $t('competitions.main.hours')
        }}
      </li>
      <li>
       {{ $t('competitions.tr.termsConditions')}}
        <router-link
          :to="{
            name: 'CompetitionRules',
            params: { id: data.cmp_id }
          }"
          >{{ $t('competitions.tr.here')}}</router-link
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'nextCompetition',
  props: {
    data: {}
  }
}
</script>

<style lang="scss">
.wrappNextCompetition {
  box-sizing: border-box;
  width: calc(50% - 15px);
  width: 48.5%;
  padding-right: 24px;
  margin-bottom: 55px;
  // background: rgba(165, 42, 42, 0.205);
  border-right: 2px solid #d9d9d9;
  // .line{
  //   background: #D9D9D9;
  //   height: 2px;
  // }
  a {
    color: $main-text-color;
  }

  .title {
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    line-height: 41px;
    /* identical to box height */

    letter-spacing: 0.06em;

    color: #424242;
  }
  .text {
    font-style: normal;
    font-weight: 400;
    font-size: 19px;
    line-height: 194.9%;
    /* or 37px */

    color: rgba(100, 100, 100, 0.96);
    margin: 37px 0 52px 0;
  }
  .subTitle {
    font-style: normal;
    font-weight: 600;
    font-size: 22px;
    line-height: 194.9%;
    /* or 43px */

    color: rgba(86, 86, 86, 0.96);
  }
  ul {
    padding-left: 20px;
    li {
      font-style: normal;
      font-weight: 400;
      font-size: 19px;
      line-height: 194.9%;
      /* or 37px */

      color: rgba(100, 100, 100, 0.96);
    }
  }
}
@media only screen and (max-width: 1000px) {
  .wrappNextCompetition {
    box-sizing: border-box;

    width: 100%;
    padding-right: 0px;
    padding-bottom: 34px;
    // margin-right: 15px;
    // background: rgba(165, 42, 42, 0.205);
    border-right: none;
    border-bottom: 2px solid #d9d9d9;
    margin-bottom: 45px;

    .title {
      font-style: normal;
      font-weight: 600;
      // font-size: 30px;
      // line-height: 41px;
      font-size: 26px;
      line-height: 36px;
      /* identical to box height */

      letter-spacing: 0.06em;

      color: #424242;
    }
    .text {
      font-style: normal;
      font-weight: 400;
      // font-size: 19px;
      // line-height: 194.9%;
      /* or 37px */
      font-size: 16px;
      line-height: 194.9%;

      color: rgba(100, 100, 100, 0.96);
      margin: 27px 0 32px 0;
    }
    .subTitle {
      font-style: normal;
      font-weight: 600;
      // font-size: 22px;
      font-size: 20px;
      line-height: 194.9%;
      /* or 43px */

      color: rgba(86, 86, 86, 0.96);
    }
    ul {
      margin: 10px 0;
      padding-left: 20px;
      li {
        font-style: normal;
        font-weight: 400;
        // font-size: 19px;
        font-size: 16px;
        line-height: 194.9%;
        /* or 37px */

        color: rgba(100, 100, 100, 0.96);
      }
    }
  }
}
</style>
